import React from 'react';

import dayjs from "dayjs";

import {Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";
import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommonInfoTab from "../Common/CommonInfoTab";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import TaskCard from "../Cards/TaskCard";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import BaseApi from "../../utils/BaseApi";
import CommonOneFieldForm from "../Common/CommonOneFieldForm";
import {NumberSliderField} from "../Common/FormFields";

// icons
import CheckIcon from '@mui/icons-material/Check';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SliceTaskAddModal from "./SliceTaskAddModal";
import Divider from "@mui/joy/Divider";
import OpportunityCard from "../Cards/OpportunityCard";
import {getWeekRange} from "../../utils/misc";


let commentExample= '<ol><li>Планируемая дата сдачи отчета по ближайшему этапу календарного плана:<ol><li>Де-факто пересчет оставшейся фактической трудоемкости в дату окончания текущего этапа с учетом рисков. </li> <li> Оценка без привязки к датам договора — беспристрастная оценка. </li> <li> Под завершением работ понимается сдача отчета Заказчику (НК + отправка), в эту дату приемка работ Заказчика не входит. </li> <li> Какие ключевые контрольные точки использованы для мониторинга выполнения этапа: ВКС с Заказчиком, отправка промежуточных результатов. </li> </ol> </li> <li> Какие существуют риски на сегодняшний день: <ol> <li > Риск по превышению трудоемкости <ol> <li> На этапе определения рисков важно описывать их в общем виде. Технические аспекты следует преобразовать в понятные для команды управления проектом термины. Технические детали следует указывать в срезах исполнителей и их задач. <ol> <li> Подумать и привести варианты решения и избежания этих рисков: <ol> <li> <p> Нужен дополнительный исполнитель </li> <li> Нужны вычислительные мощности </li> <li> Нужен эксперт </li> </ol> </li> </ol> </li> </ol> </li> <li> Риск по выполнению полного состава работ по ТЗ <ol> <li> Если пункты ТЗ не выполнимы в полном объеме и почему? </li> <li> Подумать и привести варианты решения и избежания этих рисков: <ol> <li > Нужен эксперт </li> <li> Требуется изменение состава работ </li> </ol> </li> </ol> </li> <li> Риски поведения заказчика <ol> <li> Затягивание процесса согласования, выдачи ИД и пр. Какие причины и срок задержки? </li> <li> Токсичное поведение. Как это проявляется? </li> <li> Низкий уровень зрелости и недостаточная квалификация. </li> <li> Риск изменения ИД со стороны Заказчика. </li> </ol> </li> </ol> </li> </ol>'


class SliceDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            slice: this.props.slice,
            preWeekTasks: this.props.slice.pre_week_tasks,
            postWeekTasks: this.props.slice.post_week_tasks,
        };
    }

    async retrieveSlice(){
        const api = new BaseApi();
        let url = 'slice/'+this.state.slice.id;
        let response = await api.get(url, {});
        this.setState(
            {
                slice: response.data,
                preWeekTasks: response.data.pre_week_tasks,
                postWeekTasks: response.data.post_week_tasks,
            }
        );
    }

    setPreWeekTasks(tasks){
        if (tasks){
            this.setState({
                preWeekTasks: tasks,
            })
        }

    }

    setPostWeekTasks(tasks){
        if (tasks) {
            this.setState({
                postWeekTasks: tasks,
            })
        }
    }

    setSlice(slice){
        this.setState({
            slice: slice,
        })
        this.props.callBack(slice)
    }

    async saveValue(name, value){
        const api = new BaseApi();
        let url = `slice/${this.state.slice.id}/`;
        let data = {}
        data[name] = value
        let response = await api.patch(
            url,
            data
        );
        if (response.status === 200){
            this.setSlice(
                response.data
            )
        }
    }

    async setPreWeekCompleted(){
        await this.saveValue(
            'pre_week_completed',
            true
        )
    }

    async setPostWeekCompleted(){
        await this.saveValue(
            'post_week_completed',
            true
        )
    }

    async processOneFieldForm(formData){
        for (let pair of formData.entries()){
            await this.saveValue(pair[0], pair[1])
        }
    }

    render() {
        const { start, end } = getWeekRange(this.state.slice.week, (new Date()).getFullYear());
        return (
            <Stack
                spacing={2}
                width={'100%'}
            >
                <Stack
                    direction={'row'}
                    spacing={2}
                    width={'100%'}
                >
                    {
                        this.props.showOpportunity?
                            <OpportunityCard
                                opportunity={this.state.slice.opportunity}
                                nano={true}
                            />:
                            null
                    }
                    <Chip
                        color={this.state.slice.color}
                        variant={'plain'}
                    >
                        {this.state.slice.role_human}
                    </Chip>
                    <Chip
                        color={'neutral'}
                    >
                        Год: {this.state.slice.year}
                    </Chip>
                    <Chip
                        color={'neutral'}
                    >
                        Неделя: {this.state.slice.week}
                    </Chip>
                    <Chip>
                        {dayjs(start).format('DD.MM.YYYY')} - {dayjs(end).format('DD.MM.YYYY')}
                    </Chip>
                    <Chip>
                        План: {this.state.slice.duration_plan} ч.
                    </Chip>
                    <Chip>
                        Факт {this.state.slice.duration_fact} ч.
                    </Chip>
                </Stack>
                <Stack
                    direction={'row'}
                    spacing={2}
                    width={'100%'}

                >
                    {
                        this.state.slice.role === 'R' ?
                            <Stack
                                sx={{
                                    width: !this.state.slice.pre_week_completed ? '100%' : '48%',
                                }}
                                spacing={2}
                            >
                                <Typography
                                    level="title-lg"
                                >
                                    Планирование недели
                                </Typography>

                                <Card
                                    size={'sm'}
                                >
                                    <Stack
                                        direction={'row'}
                                        spacing={1}
                                    >
                                        <Typography
                                            level="title-md"
                                        >
                                            Планируемые задачи
                                        </Typography>
                                    </Stack>
                                    {
                                        !this.state.slice.pre_week_completed && this.state.slice.pre_week_permission && this.context.subscriberObject.id === this.state.slice.operator.id ?
                                            <SliceTaskAddModal
                                                slice={this.state.slice}
                                                callBack={this.retrieveSlice.bind(this)}
                                            /> :
                                            null
                                    }
                                    <CommonPaginatedComponentList
                                        data={this.state.preWeekTasks}
                                        component={TaskCard}
                                        componentKeyword={'task'}
                                        callBack={this.setPreWeekTasks.bind(this)}
                                    />
                                </Card>
                                {
                                    this.state.slice.pre_week_permission && !this.state.slice.pre_week_completed ?
                                        <CommonCallBackButton
                                            icon={CheckIcon}
                                            label={'Подтвердить планирование'}
                                            color={'success'}
                                            variant={'solid'}
                                            callBack={this.setPreWeekCompleted.bind(this)}
                                        /> :
                                        null
                                }
                                {
                                    this.state.slice.pre_week_completed ?
                                        <Chip
                                            color={'success'}
                                        >
                                            Планирование подтверждено {this.state.slice.pre_week_completed_on}
                                        </Chip> :
                                        null
                                }
                            </Stack>:
                            null
                    }
                    {
                        this.state.slice.pre_week_completed && this.state.slice.role === 'R' ?
                            <Divider orientation="vertical"/> :
                            null
                    }
                    {
                        this.state.slice.pre_week_completed?
                            <Stack
                                spacing={2}
                                sx={{
                                    width: this.state.slice.role === 'R'?'48%':'100%',
                                }}
                            >

                                <Typography
                                    level="title-lg"
                                >
                                    Оценка недели
                                </Typography>
                                <CommonInfoTab
                                    callBack={this.setSlice.bind(this)}
                                    groups={
                                        [
                                            {
                                                // title: 'Оценка недели',
                                                // icon: <InfoIcon/>,
                                                fields: [
                                                    {
                                                        title: 'Оценка по реализации проекта в конце недели',
                                                        component: {
                                                            component: CommonOneFieldForm,
                                                            props: {
                                                                key: 'CommonOneFieldForm' + crypto.randomUUID(),
                                                                field: {
                                                                    component: NumberSliderField,
                                                                    props: {
                                                                        startDecorator: {
                                                                            component: SentimentDissatisfiedIcon,
                                                                            props: {
                                                                                color: 'danger',
                                                                                sx:{
                                                                                    height: '16px',
                                                                                    width: '16px',
                                                                                }
                                                                            }
                                                                        },
                                                                        endDecorator: {
                                                                            component: SentimentSatisfiedIcon,
                                                                            props: {
                                                                                color: 'success',
                                                                                sx:{
                                                                                    height: '16px',
                                                                                    width: '16px',
                                                                                }
                                                                            }
                                                                        },
                                                                        name: 'post_week_progress_score',
                                                                        required: true,
                                                                        defaultValue: this.state.slice.post_week_progress_score,
                                                                        min: 0,
                                                                        max: 10,
                                                                        step: 1,
                                                                        marks: true,
                                                                        disabled: this.state.slice.post_week_completed || this.context.subscriberObject.id !== this.state.slice.operator.id
                                                                    }
                                                                },
                                                                callBack: this.processOneFieldForm.bind(this)
                                                            }
                                                        }
                                                    },
                                                    {
                                                        title: 'Оценка коммуникации с заказчиком в конце недели',
                                                        component: {
                                                            component: CommonOneFieldForm,
                                                            props: {
                                                                key: 'CommonOneFieldForm' + crypto.randomUUID(),
                                                                field: {
                                                                    component: NumberSliderField,
                                                                    props: {
                                                                        startDecorator: {
                                                                            component: SentimentDissatisfiedIcon,
                                                                            props: {
                                                                                color: 'danger',
                                                                                sx:{
                                                                                    height: '16px',
                                                                                    width: '16px',
                                                                                }
                                                                            }
                                                                        },
                                                                        endDecorator: {
                                                                            component: SentimentSatisfiedIcon,
                                                                            props: {
                                                                                color: 'success',
                                                                                sx:{
                                                                                    height: '16px',
                                                                                    width: '16px',
                                                                                }
                                                                            }
                                                                        },
                                                                        name: 'post_week_communication_score',
                                                                        required: true,
                                                                        defaultValue: this.state.slice.post_week_communication_score,
                                                                        min: 0,
                                                                        max: 10,
                                                                        step: 1,
                                                                        marks: true,
                                                                        disabled: this.state.slice.post_week_completed || this.context.subscriberObject.id !== this.state.slice.operator.id,
                                                                    }
                                                                },
                                                                callBack: this.processOneFieldForm.bind(this)
                                                            }
                                                        }
                                                    },
                                                    {
                                                        title: 'Свободный комментарий в конце недели',
                                                        value: this.state.slice.post_week_comment,
                                                        html: true,
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12,
                                                        lg: 12,
                                                        edit: {
                                                            permission: !this.state.slice.post_week_completed && this.context.subscriberObject.id === this.state.slice.operator.id,
                                                            fields: ['post_week_comment', ],
                                                            baseUrl: 'slice',
                                                            obj: {
                                                                id: this.state.slice.id,
                                                                post_week_comment: (!this.state.slice.post_week_comment || this.state.slice.post_week_comment === '') && this.state.slice.role === 'A'?commentExample:this.state.slice.post_week_comment
                                                            }
                                                        }
                                                    },
                                                    {
                                                        title: 'Планируемая дата окончания ближайшего этапа',
                                                        value: this.state.slice.post_week_end_date,
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12,
                                                        lg: 12,
                                                        hide: this.state.slice.role !== 'A',
                                                        edit: {
                                                            permission: !this.state.slice.post_week_completed && this.context.subscriberObject.id === this.state.slice.operator.id,
                                                            fields: ['post_week_end_date', ],
                                                            baseUrl: 'slice',
                                                            obj: this.state.slice
                                                        }
                                                    },
                                                ]
                                            }
                                        ]
                                    }
                                />
                                {
                                    this.state.slice.role === 'R'?
                                        <Card
                                            size={'sm'}
                                        >
                                            <Stack
                                                direction={'row'}
                                                spacing={1}
                                            >
                                                <Typography
                                                    level="title-md"
                                                >
                                                    Дополнительные задачи
                                                </Typography>
                                            </Stack>
                                            {
                                                !this.state.slice.post_week_completed && this.context.subscriberObject.id === this.state.slice.operator.id?
                                                    <SliceTaskAddModal
                                                        slice={this.state.slice}
                                                        callBack={this.retrieveSlice.bind(this)}
                                                    />:
                                                    null
                                            }
                                            <CommonPaginatedComponentList
                                                data={this.state.postWeekTasks}
                                                component={TaskCard}
                                                componentKeyword={'task'}
                                                callBack={this.setPostWeekTasks.bind(this)}
                                            />
                                        </Card>:
                                        null
                                }
                                {
                                    this.state.slice.post_week_permission && !this.state.slice.post_week_completed?
                                        <CommonCallBackButton
                                            icon={CheckIcon}
                                            label={'Подтвердить оценку'}
                                            color={'success'}
                                            variant={'solid'}
                                            callBack={this.setPostWeekCompleted.bind(this)}
                                        />:
                                        null
                                }
                                {
                                    this.state.slice.post_week_completed?
                                        <Chip
                                            color={'success'}
                                        >
                                            Оценка подтверждена {this.state.slice.post_week_completed_on}
                                        </Chip>:
                                        null
                                }
                            </Stack>:
                            null
                    }
                </Stack>
            </Stack>
        )
    }
}

export default SliceDetail
